export default __webpack_public_path__ + "60236bef86eb9b3b578a111637090e00.png";